import { Component } from "react"

/* Components */
import { Layout, Tag, Pagination, Reload } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* REST API */
import { games } from "../../api/MultiPoker"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* DatePicker Settings */
registerLocale("ru", ru)

/* Moment Settings */



/* Widget Games */
class Games extends Component {

    constructor() {
        super()

        const date = utils.getDate()

        this.state = {
            data: [],
            status: "ok",
            page: 1,
            count: 0,
            number: "",
            startDate: date.startDate,
            endDate: date.endDate,
            toggleFilter: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Games list */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { number, startDate, endDate } = this.state
        const start = moment(startDate).format("YYYY-MM-DD HH:mm:ss")
        const end = moment(endDate).format("YYYY-MM-DD HH:mm:ss")
        const { uid, postfix } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Save Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        games({ uid, page, number, start, end, postfix }).then((response) => {
            if (response.status === 200) {
                window.scroll({ top: 0 })
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }

    /* On Submit */
    search = (event) => {
        event.preventDefault()
        this.load(1, true)
    }

    /* Set Number ACtion */
    setNumber = (number) => {
        if (number === "") {
            this.setState({ number }, () => this.load(1))
        }
        else {
            this.setState({ number })
        }
    }


    /* Reload Game */
    reloadGames = () => {
        const { page } = this.state
        this.load(page, true)
    }


    /* Draw time */
    _time = (time) => {

        /* Fields */
        const datetime = utils.getTime(time)

        return (
            <div className="page-table-datetime">
                <div className="page-table-time">{datetime.time}</div>
                <div className="page-table-date">{datetime.date}</div>
            </div>
        )
    }


    render = () => {

        /* Fields */
        const { status, data, page, count, number, startDate, endDate, toggleFilter } = this.state
        const { openGame } = this.props

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} inner />
        }

        return (
            <div className="multipoker--game-list">

                <div className="multipoker--game-filter">

                    <div className="multipoker--number-filter-box">

                        <div className="multipoker--number-filter">
                            <form onSubmit={this.search}>
                                <input placeholder={t("widget.searchByNumber")} value={number} onChange={(event) => this.setNumber(event.target.value)} />
                                <button onClick={() => this.load(1)}><img src="/images/search.png" alt="Search" /></button>
                            </form>
                        </div>

                        <Reload status={status} reload={() => this.load(1, true)} />

                        <div onClick={() => this.setState({ toggleFilter: !toggleFilter })} className="multipoker--number-mobile-filter">
                            <img src="/images/game/filter.png" alt="Filter" />
                        </div>

                    </div>

                    <div className={`multipoker--date-filter ${toggleFilter ? "active" : "disabled"}`}>

                        <span>{t("widget.from")}</span>

                        <DatePicker
                            selected={startDate}
                            onChange={(date) => this.setState({ startDate: date })}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            dateFormat="dd-MM-yyyy"
                            locale="ru"
                        />

                        <span>{t("widget.to")}</span>

                        <DatePicker
                            selected={endDate}
                            onChange={(date) => this.setState({ endDate: date })}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            dateFormat="dd-MM-yyyy"
                            locale="ru"
                        />

                        <button onClick={() => this.load(1, true)}>{t("filter.apply")}</button>

                    </div>

                </div>

                <div className="multipoker--game-content">

                    <div className="multipoker--content-head">
                        <div className="multipoker--content-element number">#</div>
                        <div className="multipoker--content-element">{t("widget.gameNumber")}</div>
                        <div className="multipoker--content-element">{t("widget.dealer")}</div>
                        <div className="multipoker--content-element">{t("widget.players")}</div>
                        <div className="multipoker--content-element">{t("widget.status")}</div>
                        <div className="multipoker--content-element">GGR</div>
                        <div className="multipoker--content-element">{t("widget.date")}</div>
                    </div>

                    {data.map((item, index) =>
                        <div className="multipoker--content-row" key={`${index}`} onClick={() => openGame(item.id, item.number)}>
                            <div className="multipoker--content-element number">{(page - 1) * 10 + index + 1}</div>
                            <div className="multipoker--content-element"><div className="link">#{item.number}</div></div>
                            <div className="multipoker--content-element">{item.dealer}</div>
                            <div className="multipoker--content-element">{item.players}</div>
                            <div className="multipoker--content-element">
                                {parseInt(item.isPaused) === 1 ? <Tag color="red" right={10}>{t("widget.paused")}</Tag> : ""}
                                {parseInt(item.status) === 1 ? <Tag color="blue">{t("widget.completed")}</Tag> : <Tag color="purple">{t("widget.notCompleted")}</Tag>}
                            </div>

                            <div className="multipoker--content-element">
                                <div className="multipoker--content-element-credit"><span>CREDIT:</span> {utils.convertor(item.credit, "$")}</div>
                                <div className="multipoker--content-element-debit"><span>DEBIT:</span> {utils.convertor(item.debit, "$")}</div>
                                <div className={`multipoker--content-element-ggr ${parseFloat(item.ggr) > 0 && "green"} ${parseFloat(item.ggr) < 0 && "red"}`}>
                                    {parseFloat(item.ggr) > 0 && "+ "}
                                    {parseFloat(item.ggr) < 0 && "- "}
                                    {utils.convertor(Math.abs(item.ggr), "$")}
                                </div>
                            </div>

                            <div className="multipoker--content-element last">
                                {this._time(item.createdAt)}
                                <div className="arrow" onClick={() => openGame(item.id, item.number)}>
                                    <img src="/images/arrow.png" alt="Arrow" />
                                </div>
                            </div>
                        </div>
                    )}

                </div>

                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(page, true)} />

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Games)